(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6344],{

/***/ 78987:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/checkbox-tick.3804ed83.svg","height":10,"width":12});

/***/ }),

/***/ 26693:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/close-white.d3f1a0ed.svg","height":17,"width":17});

/***/ }),

/***/ 55511:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_core_Checkbox_index_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43090);
/* harmony import */ var _components_core_Checkbox_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_components_core_Checkbox_index_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _public_icons_checkbox_tick_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78987);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19514);







const Checkbox = (props)=>{
    const [config, setConfig] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    const { textClassName ="checkbox_default" , inline =false  } = props;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,_constants_config__WEBPACK_IMPORTED_MODULE_4__/* .getConfig */ .i)().then((config)=>{
            setConfig(config === null || config === void 0 ? void 0 : config.general);
        }).catch((err)=>console.log(err));
    }, []);
    var _checkBoxAria, _tabIndex;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat((_components_core_Checkbox_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().checkboxWrapper)).concat(inline ? " ".concat((_components_core_Checkbox_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().inlineCheckbox)) : ""),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
            htmlFor: props.id,
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()({
                checkbox: true,
                "checkbox--swatch": props.swatch,
                "checkbox--black": props.type === "black"
            }),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                    "data-gbh-data-layer": props.analyticsData || null,
                    "data-gbh-data-layer-custom": props.analyticsDataCustom || null,
                    className: props.analyticsData ? "gbh-data-layer" : "",
                    type: "checkbox",
                    name: props.id,
                    id: props.id,
                    "aria-label": (_checkBoxAria = props.checkBoxAria) !== null && _checkBoxAria !== void 0 ? _checkBoxAria : props.aria,
                    tabIndex: (_tabIndex = props.tabIndex) !== null && _tabIndex !== void 0 ? _tabIndex : 0,
                    onChange: (e)=>props.onChange(e),
                    checked: props.checked,
                    disabled: props.disabled
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "checkbox__border",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "checkbox__marker",
                        children: (_public_icons_checkbox_tick_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z === null || _public_icons_checkbox_tick_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z === void 0 ? void 0 : _public_icons_checkbox_tick_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"].src */ .Z.src) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            className: "checkbox__marker-icon",
                            src: _public_icons_checkbox_tick_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"].src */ .Z.src,
                            alt: ""
                        }) : null
                    })
                }),
                (config === null || config === void 0 ? void 0 : config.swatchUrl) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "checkbox__swatch",
                    style: {
                        backgroundImage: 'url("'.concat(config === null || config === void 0 ? void 0 : config.swatchUrl).concat(props === null || props === void 0 ? void 0 : props.swatch, '?$PLPSwatch_Mobile50$")')
                    }
                }) : null,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: textClassName,
                    children: props.value
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Checkbox);
Checkbox.protoTypes = {
    textClassName: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    checked: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().bool),
    id: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    tabIndex: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().number),
    role: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    checkBoxAria: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    aria: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    swatch: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    type: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    analyticsData: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().object),
    analyticsDataCustom: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().object),
    disabled: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().bool),
    value: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().bool),
    onChange: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func)
};


/***/ }),

/***/ 27222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72433);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27514);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47956);
/* harmony import */ var _components_core_Input_Input_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21531);
/* harmony import */ var _components_core_Input_Input_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_components_core_Input_Input_module_scss__WEBPACK_IMPORTED_MODULE_6__);







const Input = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((props, ref)=>{
    var ref1;
    const inputRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const errorRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)();
    var _type;
    const [type, setType] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((_type = props.type) !== null && _type !== void 0 ? _type : "text");
    const [toggle, setToggle] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [showList, setShowList] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [matchedItem, setMatchedItem] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [selectedListItem, setListItem] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [focus, setFocus] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [autoCompleteValue, setAutoCompleteValue] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("off");
    const { showError , errorMessage , id , className =""  } = props;
    const accessibleInputProps = {
        ...props.required ? {
            required: true
        } : {},
        ...props["aria-describedby"] ? {
            "aria-describedby": props["aria-describedby"]
        } : {},
        ...props["aria-invalid"] ? {
            "aria-invalid": props["aria-invalid"]
        } : {},
        ...props["aria-errormessage"] ? {
            "aria-errormessage": props["aria-errormessage"]
        } : {},
        ...props["aria-label"] ? {
            "aria-label": props["aria-label"]
        } : {},
        ...props.inputMode ? {
            inputMode: props.inputMode
        } : {}
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (toggle) setType("text");
        else setType("password");
    }, [
        toggle
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (props.autoComplete === true) {
            setAutoCompleteValue("on");
            return;
        }
        if (props.autoComplete === false) {
            setAutoCompleteValue("off");
            return;
        }
        setAutoCompleteValue(props.autoComplete || "off");
    }, [
        props.autoComplete
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (props === null || props === void 0 ? void 0 : props.focus) {
            inputRef.current.focus();
        }
    }, [
        props === null || props === void 0 ? void 0 : props.focus
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (showError && errorMessage) {
            errorRef.current.focus();
        }
    }, [
        showError,
        errorMessage
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const keyPressEvent = (e)=>{
            const { KEYCODE  } = _constants_index__WEBPACK_IMPORTED_MODULE_5__["default"];
            if (e.keyCode === KEYCODE.TAB && showList) {
                setShowList(false);
            }
        };
        const containerTarget = (e)=>{
            var ref;
            if (showList && !((ref = document.getElementById("".concat(props.id, "-wrapper"))) === null || ref === void 0 ? void 0 : ref.contains(e.target))) setShowList(false);
        };
        window.addEventListener("click", containerTarget);
        document.addEventListener("keydown", keyPressEvent);
        return ()=>{
            document.removeEventListener("keydown", keyPressEvent);
            window.removeEventListener("click", containerTarget);
        };
    }, [
        showList
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        var ref, ref1;
        if (((ref = props.value) === null || ref === void 0 ? void 0 : ref.length) > 0 && ((ref1 = props.suggestions) === null || ref1 === void 0 ? void 0 : ref1.length) > 0) {
            setShowList(true);
            selectListItem();
            setActivedescendant();
        } else setShowList(false);
    }, [
        props.value,
        props.suggestions
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (showList) setActivedescendant();
    }, [
        showList
    ]);
    const selectListItem = ()=>{
        const listItems = [
            ...props.suggestions
        ];
        const firstMatchedItem = listItems.find((item)=>{
            if (item === null || item === void 0 ? void 0 : item.includes(props.value)) return item;
        });
        setMatchedItem(firstMatchedItem);
    };
    var _id;
    const setActivedescendant = ()=>{
        var ref;
        return setListItem((_id = (ref = document.getElementById("".concat(props.id, "-list"))) === null || ref === void 0 ? void 0 : ref.childNodes[0].id) !== null && _id !== void 0 ? _id : "");
    };
    const inputClasses = classnames__WEBPACK_IMPORTED_MODULE_2___default()("input-field__border", props.disabled ? "--disabled" : null, props.showError ? "--with-error" : null, focus ? "--focused" : null);
    const i18n = {
        show: t("kf.auth.label.show"),
        hide: t("kf.auth.label.hide"),
        resultsText: t("kf.input.aria.resultsText")
    };
    const handleClick = ()=>{
        var ref;
        return (ref = document.getElementById(props.id)) === null || ref === void 0 ? void 0 : ref.focus();
    };
    const handleKeyDown = (e)=>{
        if (showList) {
            const { KEYCODE  } = _constants_index__WEBPACK_IMPORTED_MODULE_5__["default"];
            const ele = [
                ...document.getElementById("".concat(props.id, "-list")).childNodes
            ];
            let index = 0;
            const selectedItem = ele.find((item, i)=>{
                if (item.id === selectedListItem) {
                    index = i;
                    return item;
                }
            });
            switch(e.keyCode){
                case KEYCODE.ESC:
                    setShowList(false);
                    break;
                case KEYCODE.UP:
                    e.preventDefault();
                    if (index > 0) ele.forEach((item, i)=>{
                        if (i === index - 1) {
                            item.classList.add("--hover");
                            (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .smoothScroll */ .ldy)(item);
                            setListItem(item.id);
                        } else item.classList.remove("--hover");
                    });
                    break;
                case KEYCODE.DOWN:
                    e.preventDefault();
                    if (index < ele.length - 1) ele.forEach((item, i)=>{
                        if (i === index + 1) {
                            item.classList.add("--hover");
                            (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .smoothScroll */ .ldy)(item);
                            setListItem(item.id);
                        } else item.classList.remove("--hover");
                    });
                    break;
                case KEYCODE.SPACE:
                    break;
                case KEYCODE.ENTER:
                    selectedItem.click();
                    break;
                default:
                    break;
            }
        }
    };
    var _ariaRequried;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat((_components_core_Input_Input_module_scss__WEBPACK_IMPORTED_MODULE_6___default().inputFieldWrapper), " ").concat(className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: " input-field ".concat(props.customClass ? props.customClass : ""),
            id: "".concat(props.id, "-wrapper"),
            onClick: handleClick,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: inputClasses,
                    children: [
                        props.prefix && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "input-field__prefix",
                            children: props.prefix
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "input-field__value",
                            onKeyDown: (e)=>handleKeyDown(e),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                    ref: ref !== null && ref !== void 0 ? ref : inputRef,
                                    id: props.id,
                                    type: props.type === "password" ? type : props.type,
                                    value: props.value,
                                    name: props.name,
                                    autoComplete: autoCompleteValue,
                                    maxLength: props.maxLength,
                                    disabled: props.disabled,
                                    placeholder: props.label.replace(/\*/g, ""),
                                    onChange: props.onChange,
                                    onKeyUp: props.onKeyUp,
                                    onKeyDown: props.onKeyDown,
                                    onKeyPress: handleKeyDown,
                                    onFocus: (e)=>{
                                        setFocus(true);
                                        props.onFocus && props.onFocus(e);
                                    },
                                    onBlur: (e)=>{
                                        setFocus(false);
                                        props.onBlur && props.onBlur(e);
                                    },
                                    max: props.max,
                                    min: props.min,
                                    autoFocus: props.autoFocus,
                                    "aria-required": ((_ariaRequried = props.ariaRequried) !== null && _ariaRequried !== void 0 ? _ariaRequried : props.label.indexOf("*") > 0) ? true : false,
                                    ...accessibleInputProps,
                                    // aria-activedescendant={
                                    //   props.autoComplete ? selectedListItem : "undefined"
                                    // }
                                    // aria-readonly={props.readOnly ? "true" : "false"}
                                    // aria-owns={`${props.id}-list`}
                                    // aria-expanded={props.autoComplete ? showList : "undefined"}
                                    // aria-haspopup={props.autoComplete ? "listbox" : "false"}
                                    "data-testid": "input"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                    htmlFor: props.id,
                                    children: props.label
                                })
                            ]
                        }),
                        props.type === "password" && ((ref1 = props.value) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "input-field__suffix",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                tabIndex: "0",
                                "aria-label": toggle ? "".concat(i18n.hide, " ").concat(props.label) : "".concat(i18n.show, " ").concat(props.label),
                                role: "button",
                                onClick: ()=>setToggle(!toggle),
                                className: "input-field__toggle",
                                children: toggle ? i18n.hide : i18n.show
                            })
                        }),
                        props.suffix && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "input-field__suffix",
                            children: props.suffix
                        })
                    ]
                }),
                showList && props.suggestions && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                    id: "".concat(props.id, "-list"),
                    className: "input-field__suggestions",
                    role: "listbox",
                    "aria-label": i18n.resultsText,
                    children: props.suggestions.map((item, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            id: "suggestion-list-item-".concat(i),
                            className: "input-field__list-item ".concat(matchedItem === item ? "--hover" : ""),
                            "aria-selected": selectedListItem === item ? "true" : "false",
                            role: "option",
                            onClick: ()=>props.onSelect(item),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "input-field__list-value",
                                children: item
                            })
                        }, i))
                }),
                showError && errorMessage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    ref: errorRef,
                    "aria-live": "polite",
                    role: "alert",
                    id: "".concat(id, "-error"),
                    className: "input-field__error-message",
                    children: errorMessage
                })
            ]
        })
    });
});
Input.displayName = "Input";
Input.defaultProps = {
    label: ""
};
/* harmony default export */ __webpack_exports__["Z"] = (Input);


/***/ }),

/***/ 2583:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Modal_Modal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/useWindowResize.js
var useWindowResize = __webpack_require__(18216);
;// CONCATENATED MODULE: ./src/components/core/FindingModelNumber/v1/analyticsEventType.js
const getEventFor = (type)=>{
    if (type === null || type === void 0 ? void 0 : type.subCategory1.includes("support:contact")) {
        return "support:contact:form";
    }
    if (type === null || type === void 0 ? void 0 : type.subCategory1.includes("support:find a service part")) {
        return "support:find-a-service-part";
    }
    if (type === null || type === void 0 ? void 0 : type.subCategory1.includes("my account:product registration")) {
        return "my account:register offline kohler products:product information";
    }
    var ref;
    return (ref = type === null || type === void 0 ? void 0 : type.subCategory1) !== null && ref !== void 0 ? ref : "";
};


// EXTERNAL MODULE: ./public/icons/close-white.svg
var close_white = __webpack_require__(26693);
;// CONCATENATED MODULE: ./public/icons/modal-close.svg
/* harmony default export */ var modal_close = ({"src":"/_next/static/media/modal-close.5d34d298.svg","height":29,"width":28});
// EXTERNAL MODULE: ./src/components/core/Modal/Modal.module.scss
var Modal_module = __webpack_require__(7396);
var Modal_module_default = /*#__PURE__*/__webpack_require__.n(Modal_module);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(27514);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
;// CONCATENATED MODULE: ./src/components/core/Modal/Modal.jsx









const Modal = (props)=>{
    const modalWindow = (0,react.useRef)(null);
    const closeButton = (0,react.useRef)(null);
    const [isRendered, setIsRendered] = (0,react.useState)(false);
    const [width, height] = (0,useWindowResize/* default */.Z)();
    const [style, setStyle] = (0,react.useState)({});
    const { className , children , showModal , modalTitle , labelledBy , describedBy , onModalClose , prevActiveElem , hideCloseIcon , closeButtonAnalytics , analyticsCustomData , needAnalyticsOnContentsLink , dataLayer , StickCloseButton , isWhiteCloseIcon =false  } = props;
    const waitingTImeForModalContentToLoad = 500;
    const triggerModalClose = (e)=>{
        (0,helper/* preventBodyScroll */.MVu)(false);
        onModalClose(e);
    };
    const handleKeyPress = (e)=>{
        const focusElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
        const focusContent = modalWindow.current.querySelectorAll(focusElements);
        const firstElem = focusContent[0];
        const lastElem = focusContent[focusContent.length - 1];
        if (e.key === "Escape") {
            triggerModalClose();
        }
        if (e.key === "Tab") {
            if (e.shiftKey && (document.activeElement === firstElem || document.activeElement === modalWindow.current)) {
                e.preventDefault();
                lastElem.focus();
            }
            if (!e.shiftKey && document.activeElement === lastElem) {
                e.preventDefault();
                firstElem.focus();
            }
        }
    };
    (0,react.useEffect)(()=>{
        if (width < 577 || lib/* isIOS */.gn && width < 992) {
            setStyle({
                style: {
                    height: height,
                    minHeight: height
                }
            });
        } else {
            setStyle({});
        }
    }, [
        width,
        height
    ]);
    (0,react.useEffect)(()=>{
        if (showModal) {
            if (!isRendered) {
                setIsRendered(true);
            }
            window.addEventListener("keydown", handleKeyPress);
            window.prevActiveElement = prevActiveElem !== null && prevActiveElem !== void 0 ? prevActiveElem : document.activeElement;
            modalWindow.current.focus();
            if (needAnalyticsOnContentsLink) {
                addAnalyticsForNavigationLinks();
            }
        } else {
            if (!document.getElementsByClassName("show-modal-popup").length) {
                var ref;
                (ref = window.prevActiveElement) === null || ref === void 0 ? void 0 : ref.focus();
                (0,helper/* setFocus */.kWv)(window.keyFocusCallBack);
            }
        }
        if (showModal) {
            var ref1;
            closeButton === null || closeButton === void 0 ? void 0 : (ref1 = closeButton.current) === null || ref1 === void 0 ? void 0 : ref1.focus();
        }
        (0,helper/* preventBodyScroll */.MVu)(showModal);
        return ()=>{
            window.removeEventListener("keydown", handleKeyPress);
            (0,helper/* preventBodyScroll */.MVu)(false);
        };
    }, [
        showModal
    ]);
    const getNavigationLinksEventInfo = function(link, linkName) {
        let clickInternalLinks = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "true";
        var ref;
        const type = window.adobeDataLayer.length > 1 ? window.adobeDataLayer[1]["page"]["category"] : {};
        const eventFor = getEventFor(type);
        const internalLinkType = (type === null || type === void 0 ? void 0 : (ref = type.subCategory1) === null || ref === void 0 ? void 0 : ref.includes("my account:product registration")) ? "my account:navigation" : "".concat(eventFor, ":navigation");
        return JSON.stringify({
            clickInternalLinks,
            eventAction: "".concat(eventFor, ":modal:where do i find my product model number:").concat(linkName),
            eventMsg: "n/a",
            eventName: "".concat(eventFor, ":modal:where do i find my product model number:").concat(linkName),
            eventStatus: "n/a",
            eventType: "navigation",
            internalLinkName: linkName,
            internalLinkPosition: (type === null || type === void 0 ? void 0 : type.subCategoryID) || "contact us",
            internalLinkType,
            internalLinkURL: link,
            internalLinkZoneName: "".concat(eventFor, ":modal:where do i find my product model number")
        });
    };
    const addAnalyticsForNavigationLinks = ()=>{
        setTimeout(()=>{
            modalWindow.current.querySelectorAll(".description p a").forEach((link)=>{
                link.classList.add("gbh-data-layer");
                const textContent = (link === null || link === void 0 ? void 0 : link.textContent) || (link.querySelector("u") ? link.querySelector("u").textContent : "");
                const clickInternalLinks = (textContent === null || textContent === void 0 ? void 0 : textContent.toLowerCase()) === "learn more" ? "true" : "false";
                const eventInfo = getNavigationLinksEventInfo(link.getAttribute("href"), textContent === null || textContent === void 0 ? void 0 : textContent.toLowerCase(), clickInternalLinks);
                link.setAttribute("data-gbh-data-layer", eventInfo);
            });
            modalWindow.current.querySelectorAll(".description h6 a").forEach((link)=>{
                if (link.textContent === "Learn More") {
                    link.classList.add("gbh-data-layer");
                    const eventInfo = getNavigationLinksEventInfo(link.getAttribute("href"), link.textContent.toLowerCase());
                    link.setAttribute("data-gbh-data-layer", eventInfo);
                }
            });
            modalWindow.current.querySelectorAll(".modal-popup-body a").forEach((link)=>{
                if (link.textContent === "Continue") {
                    link.classList.add("gbh-data-layer");
                    link.setAttribute("data-gbh-data-layer", dataLayer);
                }
            });
        }, waitingTImeForModalContentToLoad);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Modal_module_default()).modalWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "modal-popup ".concat(showModal ? "show-modal-popup" : "", " ").concat(className ? className : ""),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "modal-popup-content",
                role: "dialog",
                "aria-modal": true,
                tabIndex: "-1",
                "aria-labelledby": labelledBy,
                "aria-describedby": describedBy,
                ref: modalWindow,
                ...style,
                children: [
                    !hideCloseIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "close-button-holder ".concat(StickCloseButton ? "stick-close-button" : ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "close-button".concat(closeButtonAnalytics ? " gbh-data-layer" : ""),
                            "data-gbh-data-layer": closeButtonAnalytics,
                            "data-gbh-data-layer-custom": analyticsCustomData || null,
                            onClick: triggerModalClose,
                            ref: closeButton,
                            tabIndex: "0",
                            role: "button",
                            "aria-label": "Click here to close ".concat(modalTitle, " modal window"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: isWhiteCloseIcon ? close_white/* default */.Z === null || close_white/* default */.Z === void 0 ? void 0 : close_white/* default.src */.Z.src : modal_close === null || modal_close === void 0 ? void 0 : modal_close.src,
                                "aria-hidden": true,
                                role: "presentation",
                                alt: "close"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "modal-popup-body",
                        children: isRendered && showModal && children
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Modal_Modal = (Modal);


/***/ }),

/***/ 14629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47956);
/* harmony import */ var _components_core_SelectDropdown_index_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8618);
/* harmony import */ var _components_core_SelectDropdown_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_components_core_SelectDropdown_index_module_scss__WEBPACK_IMPORTED_MODULE_4__);





const SelectDropdown = (props)=>{
    const [showList, setShowList] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [opened, setOpened] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [filteredData, setFilteredData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    let isFocused = false;
    const dropDownClass = classnames__WEBPACK_IMPORTED_MODULE_2___default()({
        "select-dropdown": true,
        "dropdown--open": showList
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (showList) {
            setOpened(true);
        } else if (!showList && opened && props.onClose) {
            props.onClose();
            setOpened(false);
        }
        const targetEelement = (e)=>{
            if (showList && document.getElementById(props.id) && !document.getElementById(props.id).contains(e.target)) {
                setShowList(false);
            }
        };
        document.addEventListener("click", targetEelement);
        return ()=>{
            document.removeEventListener("click", targetEelement);
        };
    }, [
        showList
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setFilteredData(props.data);
    }, [
        props.data
    ]);
    const handleSelect = (value)=>{
        props.onChange(value);
        setShowList(false);
    };
    const handleMouseDownEvent = ()=>{
        isFocused = true;
        setShowList(!showList);
    };
    const handleBlurEvent = (e)=>{
        if (e instanceof MouseEvent) {
            isFocused;
            setShowList(false);
        }
        if (typeof props.onBlur === "function") {
            props.onBlur();
        }
    };
    const toggleList = ()=>{
        if (showList) {
            setShowList(false);
            document.getElementById(props.id).focus();
        } else {
            var ref;
            setShowList(true);
            (ref = document.getElementById("".concat(props.id, "-list"))) === null || ref === void 0 ? void 0 : ref.childNodes[0].focus();
        }
    };
    const btnKeyDown = (e)=>{
        const { KEYCODE  } = _constants_index__WEBPACK_IMPORTED_MODULE_3__["default"];
        switch(e.keyCode){
            case KEYCODE.SPACE:
                break;
            case KEYCODE.ENTER:
                e.preventDefault();
                toggleList();
                break;
            default:
                break;
        }
    };
    const handleKeyDown = (i, e)=>{
        const { KEYCODE  } = _constants_index__WEBPACK_IMPORTED_MODULE_3__["default"];
        const ele = document.getElementById("".concat(props.id, "-list")).childNodes;
        switch(e.keyCode){
            case KEYCODE.ESC:
                toggleList();
                break;
            case KEYCODE.UP:
                if (i > 0) ele[i - 1].focus();
                break;
            case KEYCODE.DOWN:
                if (i < ele.length - 1) ele[i + 1].focus();
                break;
            case KEYCODE.SPACE:
                break;
            case KEYCODE.ENTER:
                ele[i].click();
                document.getElementById(props.id).focus();
                break;
            default:
                break;
        }
    };
    const { customClass , id , tabIndex , label , ariaLabel , ariaRequired , value , ariaStateText , data , showError , errorMessage  } = props;
    const filterCityNames = (e)=>{
        var ref;
        const key = e === null || e === void 0 ? void 0 : (ref = e.key) === null || ref === void 0 ? void 0 : ref.toLowerCase();
        if ((key === null || key === void 0 ? void 0 : key.length) === 1 && (key === null || key === void 0 ? void 0 : key.match(_constants_index__WEBPACK_IMPORTED_MODULE_3__["default"].REGEX_CONTAINS_LETTER))) {
            const filtered = data === null || data === void 0 ? void 0 : data.filter((item)=>{
                return item === null || item === void 0 ? void 0 : item.toLowerCase().startsWith(key);
            });
            setFilteredData(filtered !== null && filtered !== void 0 ? filtered : data);
        } else if (key === "backspace") {
            setFilteredData(data);
        }
    };
    var ref;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_components_core_SelectDropdown_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            onClick: handleMouseDownEvent,
            onBlur: handleBlurEvent,
            className: "".concat(dropDownClass, " ").concat(customClass !== null && customClass !== void 0 ? customClass : ""),
            onKeyDown: (e)=>filterCityNames(e),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    id: id,
                    className: "select-dropdown__field ".concat(showError ? "--with-error" : ""),
                    onKeyDown: btnKeyDown,
                    tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : 0,
                    role: "combobox",
                    "aria-controls": id ? "".concat(id, "-list") : undefined,
                    "aria-expanded": showList,
                    "aria-haspopup": "listbox",
                    "aria-label": label ? label.replace(/\*/g, "") : ariaLabel ? ariaLabel.replace(/\*/g, "") : "",
                    "aria-required": (ref = ariaRequired !== null && ariaRequired !== void 0 ? ariaRequired : label === null || label === void 0 ? void 0 : label.includes("*")) !== null && ref !== void 0 ? ref : false,
                    "aria-describedby": id && value ? "".concat(id, "-selected") : undefined,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "select-dropdown__display",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    "aria-hidden": true,
                                    className: "select-dropdown__placeholder ".concat(value ? "--label" : ""),
                                    children: label
                                }),
                                value && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    id: "".concat(id, "-selected"),
                                    className: "select-dropdown__value",
                                    children: value
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "select-dropdown__icon ".concat(showList ? "--open" : ""),
                            "aria-hidden": "true",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: "/icons/down-icon.svg",
                                alt: "open-icon"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                    id: "".concat(id, "-list"),
                    className: "select-dropdown__dropdown",
                    role: "listbox",
                    tabIndex: "-1",
                    "data-testid": "select-dropdown",
                    children: [
                        !ariaStateText && (filteredData === null || filteredData === void 0 ? void 0 : filteredData.map((item, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("select-dropdown__list-item", {
                                    "selected-item": item === value
                                }),
                                "aria-selected": item === value,
                                "aria-checked": item === value,
                                role: "option",
                                tabIndex: "-1",
                                onClick: ()=>handleSelect(item),
                                onKeyDown: (e)=>handleKeyDown(i, e),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "select-dropdown__list-value",
                                    children: item
                                })
                            }, i))),
                        ariaStateText && (filteredData === null || filteredData === void 0 ? void 0 : filteredData.map((item, i)=>{
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("select-dropdown__list-item", {
                                    "selected-item": ((props === null || props === void 0 ? void 0 : props.showStateName) ? item.name : item.code) === value
                                }),
                                "aria-selected": ((props === null || props === void 0 ? void 0 : props.showStateName) ? item.name : item.code) === value,
                                "aria-checked": ((props === null || props === void 0 ? void 0 : props.showStateName) ? item.name : item.code) === value,
                                role: "option",
                                tabIndex: "-1",
                                "aria-label": item.name,
                                onClick: ()=>{
                                    return handleSelect((props === null || props === void 0 ? void 0 : props.showStateName) ? item === null || item === void 0 ? void 0 : item.name : item === null || item === void 0 ? void 0 : item.code);
                                },
                                onKeyDown: (e)=>handleKeyDown(i, e),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "select-dropdown__list-value",
                                    children: (props === null || props === void 0 ? void 0 : props.showStateName) ? item === null || item === void 0 ? void 0 : item.name : item === null || item === void 0 ? void 0 : item.code
                                })
                            }, i);
                        }))
                    ]
                }),
                showError && errorMessage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    "aria-live": "polite",
                    role: "region",
                    className: "select-dropdown__error-message",
                    children: errorMessage
                })
            ]
        })
    });
};
SelectDropdown.defaultProps = {
    label: ""
};
/* harmony default export */ __webpack_exports__["Z"] = (SelectDropdown);


/***/ }),

/***/ 45138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_core_ToolTip_Tooltip_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25219);
/* harmony import */ var _components_core_ToolTip_Tooltip_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_components_core_ToolTip_Tooltip_module_scss__WEBPACK_IMPORTED_MODULE_2__);



const ToolTip = (props)=>{
    const [{ children =null , ...attr }, setAttribute] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        id: props.id,
        role: "tooltip",
        tabIndex: props.setFocus ? 0 : -1,
        "aria-label": props.ariaLabel,
        children: props.message
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setAttribute({
            ...attr,
            children: props.message
        });
    }, [
        props.message
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        var ref;
        if (props.setFocus) (ref = document.getElementById(props.id)) === null || ref === void 0 ? void 0 : ref.focus();
    }, [
        props.setFocus
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_components_core_ToolTip_Tooltip_module_scss__WEBPACK_IMPORTED_MODULE_2___default().tooltipWrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "tooltip__container",
            role: "alert",
            "aria-live": "polite",
            children: [
                props.label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "--label",
                            children: "".concat(props.label, ":")
                        }),
                        " "
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    ...attr,
                    children: children
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ToolTip);


/***/ }),

/***/ 43090:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrapper":"Checkbox_checkboxWrapper__Fv9jK","inlineCheckbox":"Checkbox_inlineCheckbox__s9vUb"};

/***/ }),

/***/ 21531:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"inputFieldWrapper":"Input_inputFieldWrapper__nt6o0"};

/***/ }),

/***/ 8618:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SelectDropdown_wrapper__ot64Z"};

/***/ }),

/***/ 7396:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"Modal_modalWrapper__5Kda6"};

/***/ }),

/***/ 25219:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tooltipWrapper":"Tooltip_tooltipWrapper__JMsKi"};

/***/ })

}]);